(function () {
  var hero = document.querySelector('[data-fk-hero]');
  if (!hero) return;

  /* --- Transparent header: measure header height and toggle solid state --- */
  var header = document.querySelector('.section-header');
  if (header) {
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--fk-header-h', header.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    var onScroll = function () {
      document.body.classList.toggle('fk-header-solid', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Slider: scroll-snap track with arrows, counter and auto-rotate --- */
  var track = hero.querySelector('[data-fk-track]');
  var slides = track ? track.children : [];
  if (!track || slides.length < 2) return;

  var counter = hero.querySelector('[data-fk-counter]');
  var current = 0;
  var timer = null;
  var autoplaySeconds = parseInt(hero.dataset.autoplay, 10) || 0;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    track.scrollTo({ left: track.clientWidth * current, behavior: 'smooth' });
  }

  function syncFromScroll() {
    var index = Math.round(track.scrollLeft / track.clientWidth);
    if (index !== current) current = index;
    if (counter) counter.textContent = pad(current + 1) + ' / ' + pad(slides.length);
  }

  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(syncFromScroll);
  }, { passive: true });

  var prev = hero.querySelector('[data-fk-prev]');
  var next = hero.querySelector('[data-fk-next]');
  if (prev) prev.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); });
  if (next) next.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); });

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (autoplaySeconds > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    timer = setInterval(function () { goTo(current + 1); }, autoplaySeconds * 1000);
    /* A swipe is a manual choice too: stop rotating once the user interacts. */
    track.addEventListener('pointerdown', stopAutoplay, { passive: true });
  }
})();
